<template>
  <!-- 选择碎片 -->
  <div>
    <div class="add-prize" @click="visiblePrize = true">
      <i class="el-icon-plus"></i>
      <p>选择碎片</p>
    </div>
    <!-- 奖品列表 -->
    <el-dialog
      append-to-body
      :visible.sync="visiblePrize"
      title="奖品列表"
      :close-on-click-modal="false"
      width="930px"
    >
      <el-row style="margin-bottom: 20px">
        <el-input
          style="width: 200px; margin-right: 20px"
          placeholder="奖品名称搜索"
          v-model="query.name"
        ></el-input>
        <el-button type="primary" @click="getPrize">搜索</el-button>
        <el-input
          style="width: 200px; margin-left: 20px"
          placeholder="数量"
          v-model="prizeNum"
        ></el-input>
      </el-row>
      <div class="prize-list-wrap" v-loading="loadingPrize">
        <ul class="prize-list">
          <li class="prize-item" v-for="item in prizeList" :key="item.id">
            <i
              class="el-icon-plus"
              title="添加"
              @click="handleAddPrize(item)"
            ></i>
            <img style="width: 100px" :src="item.image" alt />
            <p>
              <span>{{ item.name }}</span>
            </p>
          </li>
        </ul>
      </div>
      <el-pagination
        background
        :page-size="prizeListMeta.per_page || 15"
        :total="prizeListMeta.total || 0"
        :current-page="prizeListMeta.current_page"
        @current-change="handlePrizePageChange"
        v-if="prizeListMeta && prizeListMeta.total > prizeListMeta.per_page"
      ></el-pagination>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '../../http'
import rank from '../../utils/ranks'
import quality from '../../utils/quality'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    typeNum: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      visiblePrize: false,//奖品列表显示标志
      loading: false,//加载动画
      loadingPrize: false,//加载物品列表的动画
      buttonLoading: false,//按钮加载动画
      taskData: undefined,//任务列表
      prizeList: undefined,//奖品列表
      query: {//奖品搜索
        page: 1,
        name: undefined,
      },
      prizeNum: 1,//碎片数量默认是1
      prizeListMeta: undefined,//奖品列表的底部分页
      staticData: {
        rank: rank,
        quality: quality,
      },
      taskRules: {//任务表单验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
    dialogType: {
      get() {
        return this.typeNum
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {

    },
    visiblePrize(val) {
      //监听物品列表弹窗显示
      if (val) {
        this.prizeNum = 1
        this.getPrize()
      }
    }
  },
  created() {
  },
  methods: {
    handleAddPrize(row) {
      //选择奖品并赋值
      this.visiblePrize = false
      let params = row
      params.num=this.prizeNum
      this.$emit("selectedDebrisData", params)
    },
    getPrize() {
      //查询奖品
      this.loadingPrize = true
      let params = this.query
      getApiData(`debris`, params)
        .then(res => {
          this.prizeList = res.data
          this.prizeListMeta = res
        })
        .finally(() => {
          this.loadingPrize = false
        })
    },
    handlePrizePageChange(page) {
      //奖品列表点击底部分页
      this.query.page = page
      this.getPrize()
    },
    getRank(rank) {
      for (let item of this.staticData.rank) {
        if (item.level === rank) {
          return item.text
        }
      }
    },
    getRankColor(rank) {
      for (let item of this.staticData.rank) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
.add-prize {
  width: 80px;
  padding-top: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>